import { useEffect } from 'react';
import threeWavesImage from '../assets/images/pearson-triple-wave.jpg';

interface UsePearsonThreeWavesParams {
  pathname: string;
  forRoutes: readonly string[];
}

export const PEARSON_THREE_WAVES = 'pearson-three-waves';

export const usePearsonThreeWaves = ({ pathname, forRoutes }: UsePearsonThreeWavesParams): void => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const currentRoute = pathname.split(/\//).pop() ?? '';
    const hasMatchingRoute = forRoutes.includes(currentRoute);

    document.body.classList.toggle(PEARSON_THREE_WAVES, hasMatchingRoute);
    document.body.style.backgroundImage = hasMatchingRoute ? `url('${threeWavesImage}')` : '';

    return () => {
      document.body.classList.remove(PEARSON_THREE_WAVES);
      document.body.style.backgroundImage = '';
    };
  }, [forRoutes, pathname]);
};
